import React from 'react';
import { Table, Button, Col, Row,Media,Input } from 'reactstrap';
import { Dialog } from 'primereact/dialog';
import { Password } from 'primereact/password';
import { Message } from 'primereact/message';




export const SamplesTable = ({ samples = [], onEditSample,handleOpenModalAuthorization ,handleCloseModalAuthorization,isModalAuthorization,selected,
    password,setPassword,saveValidate,invalidPasword,messageInvalid

}) => {

    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case "aceptada":
                return "#51bb25";
            case "rechazada":
                return "#de3e4d";
            case "condicionada":
                return "#efd23f";
            case "pendiente":
                return "#ff5f24";
            default:
                return "#ff5f24";
        }
    };

    return (
        <>

        <div style={{ padding: "20px" }} className='table-wrapper-mic-quoter pt-4'>
            <Table className='b-r-5 table table-sm '>
                <thead className='b-r-5'  style={{ backgroundColor: "#1d5b83" }}>
                    <tr>
                        <th style={{color:"#fff"}}>Código de muestra</th>
                        <th style={{color:"#fff"}}>Tipo de muestra</th>
                        <th style={{color:"#fff"}}>Muestra</th>
                        <th style={{color:"#fff"}}>Determinaciones</th>
                        <th style={{color:"#fff" ,textAlign:"justify" }}  >Estado</th>
                        <th style={{color:"#fff"}}>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {samples.map((sample, index) => (
                        <tr key={index}>
                            <td>{sample.code}</td>
                            <td>{sample.type_sample}</td>
                            <td>{sample.name_sample}</td>
                            <td>
                                <ul>
                                    {sample.list_exams?.map((exam, i) => (
                                        <li style={{ fontSize: "10px" }} key={i}>-{exam.name}</li>
                                    ))}
                                </ul>
                            </td>
                            <td style={{ textAlign: "center" }}>
                                <div style={{
									backgroundColor:getStatusColor(sample.status_name),
									width: "100px",
									height: "21px",
									borderRadius: "8px",
									color: "#fff",
									fontSize:"10px",
									paddingTop:"1px"
								}}>
								<label className='f-w-600' style={{fontSize:"10px"}} >{sample.status_name ?? "PENDIENTE"}</label>
								</div>
                            </td>
                            <td>
                                {
                                    sample.status_name === "ACEPTADA" && <Button
                                    color="primary"
                                    size="xs"
                                    className='fa fa-eye'
                                    onClick={() => onEditSample(sample)}
                                />
                                }
                                {
                                    sample.status_name !== "ACEPTADA" && <Button
                                    color="primary"
                                    size="xs"
                                    className='fa fa-edit'
                                    onClick={() => onEditSample(sample)}
                                />
                                }
                                {
                                    sample.status_name === "ACEPTADA" && <Button
                                    color="danger"
                                    size="xs"
                                    className='fa fa-lock'
                                    onClick={() => handleOpenModalAuthorization(sample)}
                                /> 
                                }
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div >
     <Dialog
        header={"Autorizar captura"}
        visible={isModalAuthorization}
        headerStyle={{
            backgroundColor: '#0d3b59',
            color: 'white',
            fontWeight: 'bold',
        }}
        pt={{
            header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
            headerIcon: { style: { color: 'white' } },
        }}
        onHide={handleCloseModalAuthorization}
        className="pt-0 custom-dialog-img"
        footer={ selected !=  null && selected.status_name === "ACEPTADA" &&
            <Col sm="12">  
            <button 
            onClick ={() => saveValidate(selected.id_mic_detail_sample)}
            style={{
                display: "inline-block",
                fontWeight: "400",
                color: "#ffffffff",
                textAlign: "center",
                backgroundColor:"#f97316 ",
                borderColor:"#f97316",
                borderRadius:" 0.25rem",
                fontSize:"1rem",
                lineHeight:" 1.5",
                transition:"color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                height:"30px",
                width:"120px"
            }} >
                Autorizar
            </button>
            </Col>
        }
        >
        <Col sm="12">
            {
                selected !== null &&  
                    <div className='pt-3'>  
                        <h6>Esta seguro editar la siguiente muestra: {selected.code ?? "---"} </h6> <br />
                        <Media> 
                            <br /> <br />
                            <Media 
                                style={{paddingTop:"5px"}}  
                                className="img-100 img-fluid m-r-20 rounded-circle" 
                                src={require("../../../assets/images/blog/password.svg")} 
                                alt=""
                            />
                            <Media body>
                            <Row>
                                <Col sm="1">
                                </Col>
                               <Col sm="7" className="p-0">
                                <h6 className="font-primary f-w-600"></h6>
                                <span className="d-block">
                                    <i className="icofont icofont-key"> </i>
                                    <span className="px-2">{"Acceso de autorización"}</span>
                                    <div className="card flex justify-content-center pt-2">
                                        <Password
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            toggleMask
                                            feedback={false}  
                                            invalid
                                        />
                                    </div>
                                </span>
                            </Col>
                            </Row>
                            </Media>
                        </Media>
                        <Col sm="12" className='pt-4 p-l-0 p-r-0'  >
                            {invalidPasword && (
                                        <Message severity="error" text={messageInvalid} c/>
                            )}
                        </Col>
                    </div>
            }
        </Col>
    </Dialog>

        </>

        
    );
};
